var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warning-wrapper"},[(_vm.diffInDays > 0)?_c('span',{staticClass:"warning-text"},[_vm._v(" Sua parcela vence em "+_vm._s(_vm.diffInDays)+" "+_vm._s(( _vm.diffInDays == 1 ? 'dia' : 'dias' ))+". ")]):_c('span',{staticClass:"warning-text"},[_vm._v(" Você pode pagar sua parcela hoje ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }